import _regeneratorRuntime from "@babel/runtime/regenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React from 'react';
import useApplyPricingRulesHandler from '../useApplyPricingRulesHandler';
export default function useApplyPricingRulesToCartHandler(applyRulesCtxPartial) {
  var applyPricingRulesHandler = useApplyPricingRulesHandler();
  return React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cart) {
      var _yield$applyPricingRu, _yield$applyPricingRu2, nextCart;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return applyPricingRulesHandler(applyRulesCtxPartial, cart);

            case 2:
              _yield$applyPricingRu = _context.sent;
              _yield$applyPricingRu2 = _slicedToArray(_yield$applyPricingRu, 2);
              nextCart = _yield$applyPricingRu2[1].cart;
              return _context.abrupt("return", nextCart);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [applyPricingRulesHandler, applyRulesCtxPartial]);
}